// The browser side of a story's share bar (OF.Components.Site.ShareBar).
// Each function reports what happened back to the page as the `shared`
// action: "native" (the share sheet was used), "copy" (the link is on the
// clipboard), "cancelled" or "failed". Only the first two are counted.

// Loaded with the story page: the share panel shows its "other options on
// this device" button only where the browser has a share sheet.
if (typeof navigator !== "undefined" && navigator.share) {
  document.documentElement.dataset.nativeShare = "";
}

async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return "copy";
  } catch (_error) {
    // No Clipboard API (an old browser, or a page not in a secure context):
    // the textarea trick still works almost everywhere.
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "absolute";
    area.style.left = "-9999px";
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(area);
    return copied ? "copy" : "failed";
  }
}

function report(how) {
  globalThis.Hologram.dispatchAction("shared", "page", {how});
}

export async function nativeShare(url, title) {
  if (navigator.share) {
    try {
      await navigator.share({url, title});
      report("native");
    } catch (error) {
      // Closing the sheet is an AbortError; anything else (the click no
      // longer counts as the user's, a share the browser refuses) falls
      // back to the copy, so the click still does something.
      report(error && error.name === "AbortError" ? "cancelled" : await copy(url));
    }
  } else {
    report(await copy(url));
  }
}

export async function copyLink(url) {
  report(await copy(url));
}
